import React from 'react';
import {Container, Row, Col, Table} from 'react-bootstrap';
import '../layout/main.scss';
import './viewcertificate.scss';
import spsog from '../../images/sp-sog.png';


function ViewCertificate() {
    return (
        <div className="App">
            <div className="asset">
                <Container>
                    <div className="cardAssetinfo">
                        <h4>View certificate</h4>
                        <Row>
                            <Col className="col-sm-12 col-md-6">
                                <div className="certif_img1">
                                    <img src={spsog}/>
                                </div>
                            </Col>
                            <Col className="col-sm-12 col-md-6">
                                <div className="cards">
                                    <Table>
                                        <tbody>
                                        <tr>
                                            <th>Chain</th>
                                            <td>Ethereum</td>
                                        </tr>
                                        <tr>
                                            <th>Contract ID</th>
                                            <td>0xe385g...48fh4</td>
                                        </tr>
                                        <tr>
                                            <th>Token ID</th>
                                            <td>2354</td>
                                        </tr>
                                        <tr>
                                            <th>Kiwaku staked</th>
                                            <td>Requester: 10<br/>
                                                Judge pool: 0</td>
                                        </tr>
                                        <tr>
                                            <th>Certificate content</th>
                                            <td>I certify that I own the IP of this picture for this NFT and that only one edition will ever be produced</td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <h4>Attachments</h4>
                            <Col className="col-sm-12">
                                <div className="cards">
                                    <Table hover>
                                        <tbody>
                                        <tr>
                                            <th>Title</th>
                                            <th>Type</th>
                                        </tr>
                                        <tr>
                                            <td>Photo of original art</td>
                                            <td>Picture</td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="col-sm-12 request-btn">
                                <a href=""><button>Challenge certificate</button></a>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default ViewCertificate;
